<template>
    <v-container :fluid="$vuetify.breakpoint.mdAndUp" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-flex align-center py-2 font-weight-bold primary secondary--text" style="word-break: normal">
                        <v-icon color="secondary" class="mr-2">mdi-face-agent</v-icon>
                        TICKETS POR RESPONDER
                        <v-spacer/>
                        <v-btn icon color="secondary" :loading="loading" @click="getClaims(1)">
                            <v-icon>mdi-sync</v-icon>
                        </v-btn>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps">
                        <template v-slot:item.id="{ item }">
                            <strong>{{ item.id }}</strong>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small label :color="getColor(item.status_id)" dark>{{ item.status }}</v-chip>
                        </template>
                        <template v-slot:item.module="{ item }">
                            <v-chip small label color="secondary" class="primary--text font-weight-bold">{{ item.module }}</v-chip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" small depressed dark :to="{ name: 'ClaimViewAdmin', params: { id: item.id } }">
                                <v-icon left small>mdi-chat</v-icon>Responder
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "CPending",
        props: [ 'user' ],
        data: () => ({
            search: '',
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Cliente', value: 'customer' },
                { text: 'Area', value: 'module' },
                { text: 'Referencia', value: 'reference' },
                { text: 'Motivo', value: 'reason' },
                { text: 'País', value: 'country_name' },
                { text: 'Estado', value: 'status', align: 'center', sortable: false },
                { text: 'Actualizado', value: 'updated_at' },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            desserts: [],
            expanded: [],
            loading: true,
            noDataText: 'No tienes tickets por responder',
            footerProps: {
                itemsPerPageOptions: [25, 50, 100, 250, -1]
            },
            claim: null
        }),
        created () {
            this.getClaims();
        },
        methods: {
            getClaims(v) {
                this.loading = true;
                if (v === 1) { this.desserts = []; }
                axios.get('/api/claims/pending').then((res) => {
                    this.desserts = res.data.items || [];
                    this.loading = false;
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.handleErrors(err.response.data.errors);
                    } else {
                        this.$toast.error('No fue posible cargar tickets.', { icon: 'mdi-alert-circle' });
                    }
                }).then(() => {
                    this.loading = false;
                });
            },
            getColor(status) {
                if (status === 301) return 'warning';
                if (status === 302) return 'success';
                return 'grey';
            }
        }
    }
</script>

<style scoped>

</style>
